import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const pageVisitHistorySourceDictionary = createSimpleDictionary(
    [
        { id: 1, name: 'tradeball.com' },
        { id: 2, name: '88ad1268.tradeball.com' },
        { id: 3, name: '88ad1268v3.tradeball.com' },
    ],
    ['name']
);
